export class NavigationUtils {
  static ROOT_HASH = "#/";
  static REVIEW_HASH = "#/review-invoices";

  static isAtRoot() {
    return (
      window.location.hash === this.ROOT_HASH || window.location.hash === ""
    );
  }

  static isAtReviewInvoices() {
    return (
      window.location.hash === this.REVIEW_HASH ||
      window.location.hash === "review-invoices"
    );
  }

  static findRoute() {
    const route = window.location.hash?.replace(this.ROOT_HASH, "");
    if (route) {
      const split = route.split("?");
      if (split.length > 0) {
        return split[0];
      }
    }
    return undefined;
  }
}
